

















export default {
  name: 'rules-acceptation',
  data() {
    return {
    }
  },
  computed: {
    isNews() {
      return new Date(this.$store.state.persistent.acceptedRules) < new Date('2018-08-02')
    }
  },
  methods: {
    close() {
      this.$store.dispatch('persistent/acceptRules', new Date('2018-08-02'))
    },
    openLinkFr() {
      window.openLink('https://community.meteo-parapente.com/t/the-rules-of-meteo-parapente-le-reglement-de-meteo-parapente/560/4')
    },
    openLinkEn() {
      window.openLink('https://community.meteo-parapente.com/t/the-rules-of-meteo-parapente-le-reglement-de-meteo-parapente/560')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/rules-acceptation.vue